var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgScan = function SvgScan(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.75C6.75736 5.75 5.75 6.75736 5.75 8V9H4.25V8C4.25 5.92893 5.92893 4.25 8 4.25H9V5.75H8ZM21 12.75H3V11.25H21V12.75ZM16 5.75C17.2426 5.75 18.25 6.75736 18.25 8V9H19.75V8C19.75 5.92893 18.0711 4.25 16 4.25H15V5.75L16 5.75ZM16 18.25C17.2426 18.25 18.25 17.2426 18.25 16V15H19.75V16C19.75 18.0711 18.0711 19.75 16 19.75H15V18.25H16ZM8 18.25C6.75736 18.25 5.75 17.2426 5.75 16L5.75 15H4.25L4.25 16C4.25 18.0711 5.92893 19.75 8 19.75H9V18.25H8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.75C6.75736 5.75 5.75 6.75736 5.75 8V9H4.25V8C4.25 5.92893 5.92893 4.25 8 4.25H9V5.75H8ZM21 12.75H3V11.25H21V12.75ZM16 5.75C17.2426 5.75 18.25 6.75736 18.25 8V9H19.75V8C19.75 5.92893 18.0711 4.25 16 4.25H15V5.75L16 5.75ZM16 18.25C17.2426 18.25 18.25 17.2426 18.25 16V15H19.75V16C19.75 18.0711 18.0711 19.75 16 19.75H15V18.25H16ZM8 18.25C6.75736 18.25 5.75 17.2426 5.75 16L5.75 15H4.25L4.25 16C4.25 18.0711 5.92893 19.75 8 19.75H9V18.25H8Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgScan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "scan.94794e4f9b933ac0cf83dd25be5947e1.svg";